import React from 'react';
import DocumentMeta from 'react-document-meta';

function ComingSoon() {
    const meta = {
        title: 'MetaFans Website Under Construction',
        description: 'The MetaFans NFT platform is undergoing a significant update for New Sports Season with exciting new benefits for members. Coming Soon',
    };

    return (
        <>
            <DocumentMeta {...meta} />
            <div
                className="min-h-screen flex items-center justify-center"
                style={{
                    background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://images.unsplash.com/photo-1621303837374-6f8f47b43239?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed',
                    fontFamily: "'Arial', sans-serif",
                }}
            >
                <div
                    className="relative bg-white bg-opacity-20 backdrop-blur-lg p-6 md:p-12 rounded-2xl shadow-2xl max-w-[90%] text-center transition-all duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(59,130,246,0.5)]"
                    style={{
                        border: '2px solid transparent',
                        backgroundClip: 'padding-box',
                    }}
                >
                    <div
                        className="absolute inset-0 rounded-2xl"
                        style={{
                            background: 'linear-gradient(90deg, #3b82f6, #10b981, #3b82f6, #10b981)',
                            backgroundSize: '200% 200%',
                            animation: 'shimmer 3s linear infinite',
                            padding: '2px',
                            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                            WebkitMaskComposite: 'xor',
                            maskComposite: 'exclude',
                        }}
                    ></div>
                    <div className="relative z-10">
                        <h2 className="text-2xl md:text-3xl font-semibold text-amber-400 mb-4 animate-pulse">
                            Website Under Construction
                        </h2>
                        <h1 className="text-xl md:text-3xl font-bold text-white">
                            In preparation for the <span className="text-amber-400 font-bold">New Sports Season</span>, MetaFans website is currently undergoing a significant update. We're committed to introducing many new and exciting benefits for our members.
                        </h1>
                    </div>
                </div>
            </div>
            <style>{`
                @keyframes shimmer {
                    0% { background-position: 0% 50%; }
                    100% { background-position: 200% 50%; }
                }
            `}</style>
        </>
    );
}

export default ComingSoon;